import type { Dispatch, ReactElement, SetStateAction } from 'react';

export function SelectField({
  options,
  label,
  disabled,
  value,
  update,
}: {
  options: string[];
  label: string;
  disabled?: boolean;
  value: string;
  update: Dispatch<SetStateAction<string>>;
}): ReactElement {
  function select(val: string) {
    update(val);
  }

  return (
    <div
      className="relative mb-7 block border-0 border-b
    border-solid border-[#dadbdc] bg-transparent text-left duration-200 after:pointer-events-none after:absolute after:right-0
    after:top-1/2 after:h-5 after:w-5 after:-translate-y-2/4 after:bg-[url('data:image/svg+xml,%0A%3Csvg%20fill%3D%22%23000000%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20width%3D%2224%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M7.41%207.84L12%2012.42l4.59-4.58L18%209.25l-6%206-6-6z%22/%3E%0A%20%20%20%20%3Cpath%20d%3D%22M0-.75h24v24H0z%22%20fill%3D%22none%22/%3E%0A%3C/svg%3E')] 
    after:bg-contain after:bg-center after:bg-no-repeat after:opacity-50 after:duration-200 dark:after:invert"
    >
      <label
        htmlFor={label}
        className="absolute left-0 top-[-1rem] block origin-top-left scale-85 
      text-black opacity-50 duration-200 dark:text-white"
      >
        {label}
      </label>
      <select
        name={label}
        className="m-0 w-full appearance-none border-none bg-transparent p-0 pr-4 text-black dark:text-white"
        disabled={disabled}
        value={value}
        onChange={(e) => {
          select(e.target.value);
        }}
      >
        <option disabled> </option>
        {options.map((val, i) => (
          <option value={val} key={`${label}-${i}`} className="text-black">
            {val}
          </option>
        ))}
      </select>
    </div>
  );
}
